import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VhqMessageBoxComponent } from './vhq-message-box.component';

@NgModule({
  declarations: [VhqMessageBoxComponent],
  imports: [CommonModule],
  exports: [VhqMessageBoxComponent],
})
export class VhqMessageBoxModule {}
